module.exports = __webpack_public_path__ + "static/media/Solomon Islands.e4249cdd.png";